import { createMathPlugin } from '@streamdown/math'
import { defaultRehypePlugins, defaultRemarkPlugins } from 'streamdown'

// Configure math plugin to support both $ and $$ syntax
const mathPlugin = createMathPlugin({
  singleDollarTextMath: true,
})

// Pre-configured plugins with math support
export const remarkPlugins = [
  ...Object.values(defaultRemarkPlugins),
  mathPlugin.remarkPlugin,
]

export const rehypePlugins = [
  ...Object.values(defaultRehypePlugins),
  mathPlugin.rehypePlugin,
]
